<div class="et-participant-header flex justify-content-between">
  <div>
    <span class="title3Font">{{ header }}</span>
    @if (subHeader) {
      <span class="block body2Font">{{ subHeader }}</span>
    }
  </div>

  <span class="p-buttonset">
    <p-button [styleClass]="showInProgressOnly ? 'et-active' : 'et-inactive'"
              icon="fas fa-chart-line"
              (onClick)="showInProgress()"
              label="In progress ({{ inProgressCount }})"
              i18n-label>
    </p-button>
    <p-button [styleClass]="showPublishedOnly ? 'et-active' : 'et-inactive'"
              icon="fas fa-check"
              (onClick)="showPublished()"
              label="Published ({{ publishedCount }})"
              i18n-label>
    </p-button>
  </span>
</div>